import * as Yup from 'yup'

export const initialCreateFormValues = (values) => {
    return {
        vendor_id: values.vendor_id || "",
        first_name: values.first_name || "",
        last_name: values.last_name || "",
        company_name: values.company_name || "",
        license_number: values.license_number || "",
        email: values.email || "",
        address: values.address || "",
        address1: values.address1 || "",
        country: values.country || "",
        state: values.state || "",
        city: values.city || "",
        zipcode: values.zipcode || "",
        phone: values.phone || "",
        mobile: values.mobile || "",
        fax: values.fax || ""
    }
}

export const formValidationSchema = Yup.object({
    first_name: Yup.string().required("This field is required"),
    last_name: Yup.string().required("This field is required"),
    company_name: Yup.string().required("This field is required"),
    license_number: Yup.string().required("This field is required"),
    email: Yup.string().required("This field is required"),
})
